import React, { Fragment } from 'react';
import { Container, Header, List, Divider } from 'semantic-ui-react';

import './style.css';

class Info extends React.Component{
  render(){
    return <Fragment>
    <Container text>
    <Header as='h3'>
      Contact Us
    </Header>
    <Divider />
    <List>
    <List.Item>
    <List.Content>
    <a href='mailto:guy.marshall@ovcinvestments.com'>Guy Marshall (email: guy.marshall@ovcinvestments.com)</a>
      </List.Content>
     </List.Item>
     <List.Item>
       <List.Content>
         <a href='mailto:peter.cheung@ovcinvestments.com'>Peter Cheung (email: peter.cheung@ovcinvestments.com)</a>
       </List.Content>
     </List.Item>
   </List>
   </Container>
   <Divider />
   <Container text textAlign="left" className='quote'>
    <p><i>"...We choose to go to the Moon in this decade and do the other things, not because they are easy,
    but because they are hard; because that goal will serve to organize and measure the best of our energies and skills,
    because that challenge is one that we are willing to accept, one we are unwilling to postpone, and one we intend to win, and
    the others, too."</i>&nbsp; (John F. Kennedy, 1962) </p>
    </Container>
    </Fragment>;
  }
}

export default Info;
